import React from 'react';
import { motion } from 'framer-motion';
export function WhySystem() {
  return <section className="border-y border-acad-line bg-white px-4 py-20 sm:py-24" data-id="element-263" data-mp="1u23uf2ptptzv">
      <motion.div initial={{
      opacity: 0,
      y: 16
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.28,
      ease: [0.23, 1, 0.32, 1]
    }} className="mx-auto max-w-3xl text-center" data-id="element-264" data-mp="1tzzhjv9y5kng">
        <p className="text-sm font-bold uppercase tracking-[0.16em] text-acad-gold" data-id="element-265" data-mp="2csbs35ar7s8o">
          Why instructors use a complete system
        </p>
        <h2 className="mt-3 font-display text-4xl font-semibold leading-tight text-acad-ink sm:text-5xl" data-id="element-266" data-mp="240jl54kxv18u">
          A good class should not depend on how much free time you had the night
          before.
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-base leading-7 text-acad-muted" data-id="element-267" data-mp="2whcikxxa4a25">
          Your students should receive a structured learning experience whether
          you had three hours to prepare or twenty minutes. A teaching system
          makes that possible.
        </p>

        <div className="mt-10 grid gap-5 text-left sm:grid-cols-2" data-id="element-268" data-mp="1idqtim4p2zom">
          <div className="rounded-2xl border border-acad-line bg-acad-canvas p-6" data-id="element-269" data-mp="1ig3jnmklwgcr">
            <p className="text-xs font-bold uppercase tracking-[0.13em] text-acad-muted" data-id="element-270" data-mp="1dlr1dfuv9b2l">
              Instead of asking
            </p>
            <p className="mt-3 font-display text-2xl font-semibold text-acad-ink" data-id="element-271" data-mp="1nd3q3yldbl4e">
              “What should I teach today?”
            </p>
          </div>
          <div className="rounded-2xl border border-acad-gold/60 bg-acad-goldSoft/60 p-6" data-id="element-272" data-mp="21ccw65fv0yun">
            <p className="text-xs font-bold uppercase tracking-[0.13em] text-acad-goldDark" data-id="element-273" data-mp="1wf37wt47it8e">
              You begin asking
            </p>
            <p className="mt-3 font-display text-2xl font-semibold text-acad-ink" data-id="element-274" data-mp="70olifgnvig2">
              “Which lesson best matches what these students need today?”
            </p>
          </div>
        </div>

        <p className="mt-8 text-lg font-semibold text-acad-gold" data-id="element-275" data-mp="2713ciubvy2xk">
          That is a completely different way to teach.
        </p>
      </motion.div>
    </section>;
}